import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import customsIcon from './customsIcon.svg'

const CustomsChip = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Chip label={t('Aduanas')} Icon={() => <img src={customsIcon} />} backgroundColor={theme.colors.warning.surface} />
  )
}

export default CustomsChip
